import { Col, Row, Spin, Typography } from "antd";
import { ReactNode, useEffect, useState } from "react";
import { EnumItemType, Person } from "../../../../../types/appTypes";
import { UpdatedValue } from "../../../../../types/entityRecordingTypes";
import { Primitive } from "../../../../../types/utilTypes";
import { formatValue } from "./formatting";
import { dataKeyLabels } from "./keyLabelMap";

type ValueType = EnumItemType | Primitive | Person
export type ValueChange = {
  [x: string]: UpdatedValue<ValueType> | UpdatedValue<ValueType>[]
}

type Props = {
  changedFields: ValueChange;
}
export function FieldChangeList({ changedFields }: Props) {
  const [dataPoints, setDataPoints] = useState<{ label: ReactNode, oldValue: ReactNode, newValue: ReactNode }[]>([])
  const [generatingOutput, setGeneratingOutput] = useState(false)
  useEffect(() => {
    let mounted = true;
    const load = async () => {
      setGeneratingOutput(true)
      const fields = []
      for (const key in changedFields) {
        const value = changedFields[key]
        const label = dataKeyLabels[key] ?? key;


        let oldValue = null;
        let newValue = null;
        if (Array.isArray(value)) {
          const oldValues: ValueType[] = []
          const newValues: ValueType[] = []
          for (const val of value) {
            val.old && oldValues.push(val.old)
            val.new && newValues.push(val.new)
          }
          oldValue = await formatValue(key, oldValues);
          newValue = await formatValue(key, newValues);
        } else {
          oldValue = await formatValue(key, value?.old);
          newValue = await formatValue(key, value?.new);
        }

        fields.push({ label, oldValue, newValue })
      }
      if (mounted) {
        setGeneratingOutput(false)
        setDataPoints(fields)
      }
    }
    load();
    return () => {
      mounted = false;
    }
  }, [changedFields])

  return (
    <Spin size="small" spinning={generatingOutput}>
      <div>
        {dataPoints?.map((item, i) => {
          return (
            <DataPoint key={item.label + "_" + i} noMarginTop={i === 0} label={item.label} oldValue={item.oldValue} newValue={item.newValue} />
          )
        })}
      </div>
    </Spin>
  )
}

type DataPointProps = {
  label: ReactNode,
  oldValue: ReactNode,
  newValue: ReactNode,
  noMarginTop?: boolean
}
export function DataPoint({ label, newValue, oldValue, noMarginTop }: DataPointProps) {
  return (
    <Row align="middle" className={`${noMarginTop ? "" : "mt-01"} text-smallest`} gutter={8}>
      <Col flex="168px">
        {label}:
      </Col>
      <Col style={{ display: "flex", gap: 4 }}>
        <Typography.Text type="secondary">{oldValue}</Typography.Text>
        <Typography.Text>{'→'}</Typography.Text>
        <Typography.Text className='text-medium'>{newValue}</Typography.Text>
      </Col>
    </Row>
  )
}
